// 座机
export const LAND_LINE = 1;
// 手机号
export const MOBILE = 2;
// 400/800
export const FIXED_LINE = 3;

export const phoneRules = ruleObj => [
  {
    validator: (rule, value, callback) => {
      if (rule.required && !value?.length) {
        callback(rule.message || '请输入电话');
        return;
      }
      (value || []).forEach(item => {
        if (item.type === LAND_LINE) {
          if (!item.areaCode || item.areaCode.length < 3) {
            callback('请输入正确的区号');
            return;
          }
        }
        if (rule.required && !item.entity) {
          callback(rule.message || '请输入电话');
          return;
        }
      });
      callback();
    },
    ...ruleObj,
  },
];

export const osPhoneRules = ruleObj => [
  {
    validator: (rule, value, callback) => {
      if (rule.required && !value?.length) {
        callback(rule.message || '请输入电话');
        return;
      }
      callback();
    },
    ...ruleObj,
  },
];
